import * as firebase from 'firebase';

var config = {
    apiKey: 'AIzaSyAcBIJr7e2aTj6Gp4Y_ioZgENhFM-c0DCo',
    authDomain: 'ttgif-3c665.firebaseapp.com',
    databaseURL: 'https://ttgif-3c665.firebaseio.com',
    projectId: 'ttgif-3c665',
    storageBucket: 'ttgif-3c665.appspot.com',
    messagingSenderId: '927756123615'
};

const Backend = firebase.initializeApp(config);

export default Backend;


// WEBPACK FOOTER //
// ./src/api/Backend.ts